<template>
    <div class="popup-notas">
        <div class="overlay" @click="close"></div>
        <div class="content">
            <div class="row">
                <div class="sm-8">
                    <p>Forma de pagamento contratada:</p>
                </div>
                <div class="sm-4 text-right">
                    <a class="close-button" @click="close">
                        <i class="mdi mdi-close mdi-18px"></i>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="sm-6">
                    <button
                        class="default-button full"
                        :class="Modo == 'À Vista' ? '' : 'red'"
                        @click="Modo = 'À Vista'"
                    >
                        À Vista
                    </button>
                </div>
                <div class="sm-6">
                    <button
                        class="default-button full"
                        :class="Modo == 'Parcelado' ? 'red' : ''"
                        @click="Modo = 'Parcelado'"
                        v-if="parcelamento_maximo >= 2"
                    >
                        Parcelado
                    </button>
                </div>
            </div>
            <div v-if="Modo == 'À Vista'">
                <div v-if="sub_contas.length != 0">
                    <div class="row">
                        <div class="sm-12">
                            <p>
                                <br />
                                Debitar da Subconta?
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="sm-6">
                            <button
                                class="default-button full"
                                :class="lancar_subconta ? '' : ''"
                                @click="
                                    () => {
                                        this.lancar_subconta = true;
                                        this.codigo_subconta = 0;
                                    }
                                "
                            >
                                Sim
                            </button>
                        </div>
                        <div class="sm-6">
                            <button
                                class="default-button full"
                                :class="!lancar_subconta ? 'red' : ''"
                                @click="
                                    () => {
                                        this.lancar_subconta = false;
                                        this.codigo_subconta = 0;
                                    }
                                "
                            >
                                Não
                            </button>
                        </div>
                    </div>
                    <div v-if="lancar_subconta">
                        <div class="row">
                            <div class="sm-12">
                                <p>
                                    <br />
                                    Favor informar qual a Subconta:
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="sm-12">
                                <div class="responsive-table">
                                    <table class="default-table">
                                        <thead>
                                            <tr>
                                                <th>Subconta</th>
                                                <th width="10%"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="subconta in sub_contas"
                                                :key="subconta.Codigo"
                                                @click="
                                                    codigo_subconta =
                                                        subconta.Codigo
                                                "
                                            >
                                                <td>{{ subconta.Descricao }}</td>
                                                <td align="center">
                                                    <label>
                                                        <i
                                                            class="mdi mdi-checkbox-marked mdi-24px"
                                                            v-if="
                                                                codigo_subconta ==
                                                                subconta.Codigo
                                                            "
                                                        ></i>
                                                        <i
                                                            class="mdi mdi-square-outline mdi-24px"
                                                            v-else
                                                        ></i>
                                                        <input
                                                            type="radio"
                                                            :value="subconta.Codigo"
                                                            :checked="
                                                                codigo_subconta ==
                                                                subconta.Codigo
                                                            "
                                                        />
                                                    </label>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="Subconta">
                            <div class="sm-12">
                                <p>
                                    <br />
                                    Deseja autorizar o pagamento à vista no
                                    valor de R$ {{ valor | number_format }} na
                                    Subconta {{ Subconta.Descricao }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="sm-12">
                                <p>
                                    <br />
                                    Deseja autorizar o pagamento à vista no
                                    valor de R$ {{ valor | number_format }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="sm-12">
                            <p>
                                <br />
                                Deseja autorizar o pagamento à vista no valor de
                                R$ {{ valor | number_format }}?
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="sm-12">
                        <p>
                            <br />
                            Favor informar qual a condição de pagamento:
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="sm-12">
                        <div class="responsive-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Parcelas</th>
                                        <th width="10%"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="parcela in parcelas"
                                        :key="parcela.id"
                                        @click="installments = parcela.parcela"
                                        :class="
                                            installments == parcela.parcelas
                                                ? 'selected'
                                                : ''
                                        "
                                    >
                                        <td>{{ parcela.parcela }}</td>
                                        <td align="center">
                                            <label>
                                                <i
                                                    class="mdi mdi-checkbox-marked mdi-24px"
                                                    v-if="
                                                        installments ==
                                                        parcela.parcela
                                                    "
                                                ></i>
                                                <i
                                                    class="mdi mdi-square-outline mdi-24px"
                                                    v-else
                                                ></i>
                                                <input
                                                    type="radio"
                                                    :value="parcela.parcela"
                                                    :checked="
                                                        installments ==
                                                        parcela.parcela
                                                    "
                                                />
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>

                <div v-if="sub_contas.length != 0">
                    <div class="row">
                        <div class="sm-12">
                            <p>
                                <br />
                                Lançar na Subconta?
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="sm-6">
                            <button
                                class="default-button full"
                                :class="!lancar_subconta ? 'red' : ''"
                                @click="
                                    () => {
                                        this.lancar_subconta = false;
                                        this.codigo_subconta = 0;
                                    }
                                "
                            >
                                Não
                            </button>
                        </div>
                        <div class="sm-6">
                            <button
                                class="default-button full"
                                :class="lancar_subconta ? 'red' : ''"
                                @click="
                                    () => {
                                        this.lancar_subconta = true;
                                        this.codigo_subconta = 0;
                                    }
                                "
                            >
                                Sim
                            </button>
                        </div>
                    </div>
                    <div v-if="lancar_subconta">
                        <div class="row">
                            <div class="sm-12">
                                <p>
                                    <br />
                                    Favor informar qual a Subconta:
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="sm-12">
                                <div class="responsive-table">
                                    <table class="default-table">
                                        <thead>
                                            <tr>
                                                <th>Subconta</th>
                                                <th width="10%"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="subconta in sub_contas"
                                                :key="subconta.Codigo"
                                                @click="
                                                    codigo_subconta =
                                                        subconta.Codigo
                                                "
                                            >
                                                <td>{{ subconta.Descricao }}</td>
                                                <td align="center">
                                                    <label>
                                                        <i
                                                            class="mdi mdi-checkbox-marked mdi-24px"
                                                            v-if="
                                                                codigo_subconta ==
                                                                subconta.Codigo
                                                            "
                                                        ></i>
                                                        <i
                                                            class="mdi mdi-square-outline mdi-24px"
                                                            v-else
                                                        ></i>
                                                        <input
                                                            type="radio"
                                                            :value="subconta.Codigo"
                                                            :checked="
                                                                codigo_subconta ==
                                                                subconta.Codigo
                                                            "
                                                        />
                                                    </label>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="Subconta">
                            <div class="sm-12">
                                <p>
                                    <br />
                                    Deseja autorizar o pagamento em
                                    {{ installments }} vezes na Subconta
                                    {{ Subconta.Descricao }}?
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="sm-12">
                                <p>
                                    <br />
                                    Deseja autorizar o pagamento em
                                    {{ installments }} vezes?
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="sm-12">
                            <p>
                                <br />
                                Deseja autorizar o pagamento em
                                {{ installments }} vezes?
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="codigo_subconta != 0 || !lancar_subconta">
                <hr />
                <div class="row">
                    <div class="sm-6">
                        <button class="default-button full" @click="confirmar">Confirmar</button>
                    </div>
                    <div class="sm-6">
                        <button class="default-button full" @click="close">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '/plugins/api';
import Swal from 'sweetalert2';
export default {
    props: ["nota"],
    filters: {
        number_format(value) {
            return new Intl.NumberFormat("pt-BR", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        },
    },
    data() {
        return {
            Modo: "À Vista",
            lancar_subconta: false,
            codigo_subconta: 0,
            QtdParcelas: 1,
            juros: [
                4.04,
                5.24,
                5.91,
                6.58,
                7.25,
                7.92,
                8.84,
                9.51,
                10.18,
                10.85,
                11.52,
                12.19,
            ],
        };
    },
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        idDocsprime() {
            return this.nota.idDocsprime;
        },
        codigo() {
            return this.nota.codigoAutorizacao;
        },
        parcela() {
            return this.nota.parcela;
        },
        parcelamento_maximo() {
            return this.nota.parcelamentoMaximo;
        },
        valor() {
            return this.nota.valor;
        },
        sub_contas() {
            
            return this.nota.SubContas;
        },
        Subconta() {
            return this.sub_contas.find(
                (s) => s.Codigo == this.codigo_subconta
            );
        },
        installments: {
            get() {
                return this.QtdParcelas;
            },
            set(parcelas) {
                if (parcelas > this.parcelamento_maximo) {
                    parcelas = this.parcelamento_maximo;
                }
                this.QtdParcelas = parcelas;
            },
        },
        parcelas() {
            let juros = this.juros;
            let valor = +this.valor;
            juros = [];
            for (let i = 1; i <= this.parcelamento_maximo; i++) {
                juros.push(0);
            }

            let parcelas = juros
                .map((taxa, i) => {
                    let parcela = i + 1;
                    let total = valor / (1 - taxa / 100);
                    let valor_parcela =
                        Math.ceil((100 * total) / parcela) / 100;
                    total = Math.round(valor_parcela * parcela * 100) / 100;
                    return {
                        id: `${i}.${valor_parcela}`,
                        parcela,
                        total,
                        valor: valor_parcela,
                    };
                })
                .filter(
                    ({ parcela }) =>
                        parcela != 1 && parcela <= this.parcelamento_maximo
                );
            return parcelas;
        },
        installment() {
            let parcela = this.parcelas.find(
                ({ parcela }) => parcela == this.installments
            );
            return parcela;
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async confirmar() {
            try {
                let { isConfirmed } = await Swal.fire({
                    title: "Deseja realmente autorizar?",
                    showCancelButton: true,
                    cancelButtonText: "Não",
                    confirmButtonText: "Sim"
                });
                if (!isConfirmed) {
                    return;
                }
                let formData = {
                    ...this.nota,
                    motivo: '',
                    autorizado: 'S',
                    quantidadeParcela: this.installments
                };
                if (this.Subconta) {
                    formData.codigoSubConta = this.Subconta.Codigo;
                    formData.descricaoSubConta = this.Subconta.Descricao;
                }
                let { data: { success, mensagem = 'Informamos que o pagamento será realizado mediante disponibilidade de saldo' } } = await api.post(`condominios/${this.codigo_condominio}/autorizacao-notas/processar`, formData);
                if (!success) {
                    throw new Error("Não foi possível alterar a autorização.");
                }
                Swal.fire({
                    icon: 'success',
                    title: "Sucesso!",
                    text: mensagem
                });
                this.$emit('success');
                this.close();
            } catch (err) {
                this.errors = [];
                let text =
                    err.message ||
                    "Não foi possível enviar sua resposta.";

                if (err.response && err.response.data) {
                    text = err.response.data.error;
                }
                Swal.fire({
                    icon: "error",
                    title: "Oops",
                    text,
                });
                console.error(err);
                this.errors = [...this.errors, err];
            }
        }
    }
};
</script>
<style lang="less" scoped>
.popup-notas {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.75);
    }
    .content {
        position: relative;
        background: white;
        width: 800px;
        max-width: 80vw;
        max-height: 80vh;
        overflow: auto;
        padding: 1em;
        table {
            tbody {
                tr {
                    cursor: pointer;
                    td {
                        input[type="radio"] {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>